/** GetPermissions feature id gating every Action Items surface (fail-closed). */
export const ACTION_ITEMS_FEATURE_ID = 'action_items';

/** Authoring caps, mirroring the Smithy @length bounds on PublishActionItem. */
export const ACTION_ITEM_HEADING_MAX = 200;
export const ACTION_ITEM_MESSAGE_MAX = 5000;
